import React, { useState, useEffect } from 'react'
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
// import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    const {exam_id} = useParams();
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [QuestionsData, setQuestionsData] = useState([]);
    const [Loading, setLoading] = useState(true);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchQuestionsData = async () => {
        const filter = { id: store_data?.org_id, exam_id: exam_id }
        const response = await postAPI("/questions/exam-wise-question-list", {...filter, user: store_data});
        if (response?.status) {
            setQuestionsData(response?.data)
            setLoading(false)
        } else {
            setQuestionsData([])
            setLoading(false)
        }
    }

    const handleChangeStatus = async (id, status) => {
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/questions/toggle-status", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Status changed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, is_trash: 1 }
        const response = await postAPI("/questions/remove", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Question removed successfully.');
            window.location.reload()
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanExport(true);
                fetchQuestionsData();
            } else {
                const viewAllowed = await hasPermission("EXAM", "Questions", "VIEW");
                const createAllowed = await hasPermission("EXAM", "Questions", "CREATE");
                const editAllowed = await hasPermission("EXAM", "Questions", "EDIT");
                const deleteAllowed = await hasPermission("EXAM", "Questions", "DELETE");
                const toggleAllowed = await hasPermission("EXAM", "Questions", "TOGGLE_STATUS");
                const exportAllowed = await hasPermission("EXAM", "Questions", "EXPORT");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanExport(exportAllowed);
                
                if (viewAllowed) {
                    fetchQuestionsData();
                }
            }
        };
        checkPermissions();
    }, [])
    return (
        <>
            <div className="container-fluid mb-3 gap-2 p-0 d-flex justify-content-end">
                <button className="btn btn-primary btn-sm" disabled={!canExport}>
                    <Excel
                        data={{ Name: "Questions", Data: QuestionsData }}
                        filename="questions-export.xlsx"
                    >
                        <DownloadOutlined /> Export
                    </Excel>
                </button>
            </div>
            <table class="table card-table">
                <thead>
                    <tr>
                        <th>Question</th>
                        <th>MCQ ?</th>
                        <th>Answer</th>
                        <th>Hint</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : QuestionsData && QuestionsData?.length > 0 ?
                            QuestionsData?.map((val, index) => (
                                <tr key={index + 1}>
                                    <td>{val?.question}</td>
                                    <td>{val?.is_mcq ? "MCQ" : "Descriptive"}</td>
                                    <td>{val?.answer}</td>
                                    <td>{val?.hint}</td>
                                    <td>
                                        {canToggleStatus ? (
                                            <span className="custom-tooltip">
                                                <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.status)}>{val?.status === 1 ? 'Active' : 'Inactive'}</span>
                                                <span className="tooltip-text">Change Status</span>
                                            </span>
                                        ) : (
                                            <span className={`badge ${val?.status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1`}>{val?.status === 1 ? 'Active' : 'Inactive'}</span>
                                        )}
                                    </td>
                                    <td>
                                        {canEdit && (
                                            <span className="custom-tooltip">
                                                <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span>
                                                <span className="tooltip-text">Edit Question</span>
                                            </span>
                                        )}
                                        {canDelete && (
                                            <span className="custom-tooltip">
                                                <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                                <span className="tooltip-text">Delete Question</span>
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))
                            : ''
                    }
                </tbody>
            </table>
        </>
    )
}
